module.exports = __webpack_public_path__ + "img/center_reight.a6e834c9.svg";